import React, { useEffect, useState } from "react";
import { useTheme, Stack, Typography, Box } from "@musatech/musa-design-system";
import appStoreImage from "../../assets/app_store.png";
import googlePlayImage from "../../assets/google_play.png";

import "./ModalDeprecated.css";

interface ModalDeprecatedProps {
  show: boolean;
}

const ModalDeprecated = ({ show }: ModalDeprecatedProps) => {
  const theme = useTheme();

  const [visible, setVisible] = useState(show);
  const [animationClass, setAnimationClass] = useState("");

  useEffect(() => {
    if (show) {
      setVisible(true);
      setAnimationClass("fade-in");
    } else {
      setAnimationClass("fade-out");
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`modal ${animationClass}`}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      <Box
        style={{
          backgroundColor:
            theme.musa.colors.semantic.background.neutral.primary,
          borderRadius: theme.musa.border.radius.medium,
          maxWidth: "400px",
          width: "100%",
          padding: theme.musa.spacing[200],
          position: "relative",
          maxHeight: "calc(100vh - 32px)",
          overflowY: "auto",
          boxSizing: "border-box",
        }}
      >
        <Stack direction="column" spacing="200">
          <Box style={{ textAlign: "center" }}>
            <Typography
              type="heading"
              size="medium"
              color={theme.musa.colors.semantic.content.primary}
              style={{ marginBottom: theme.musa.spacing[100] }}
            >
              📱 Aplicativo Descontinuado
            </Typography>

            <Typography
              type="body"
              size="small"
              color={theme.musa.colors.semantic.content.secondary}
              style={{ marginBottom: theme.musa.spacing[200] }}
            >
              Este aplicativo foi descontinuado. Para continuar utilizando
              nossos serviços, baixe o novo aplicativo Musa Transportador 2.0.
            </Typography>
          </Box>

          <Box>
            <Typography
              type="label"
              size="medium"
              color={theme.musa.colors.semantic.content.primary}
              style={{ marginBottom: theme.musa.spacing[200] }}
            >
              📲 Baixe o novo aplicativo:
            </Typography>

            <Stack direction="column" spacing="200">
              <button
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=co.musa.transportadores",
                    "_blank"
                  )
                }
                style={{
                  backgroundColor:
                    theme.musa.colors.semantic.background.neutral.secondary,
                  border: `1px solid ${theme.musa.colors.semantic.border.neutral}`,
                  cursor: "pointer",
                  borderRadius: theme.musa.border.radius.small,
                  transition: "transform 0.2s ease",
                  padding: theme.musa.spacing[100],
                  display: "flex",
                  alignItems: "center",
                  gap: theme.musa.spacing[100],
                  width: "100%",
                  minHeight: "48px",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.02)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={googlePlayImage}
                  alt="Baixar na Google Play"
                  style={{
                    height: "32px",
                    width: "auto",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  type="label"
                  size="small"
                  color={theme.musa.colors.semantic.content.primary}
                >
                  Baixar na Google Play
                </Typography>
              </button>

              <button
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/br/app/musa-transportador-2-0/id6747049877",
                    "_blank"
                  )
                }
                style={{
                  backgroundColor:
                    theme.musa.colors.semantic.background.neutral.secondary,
                  border: `1px solid ${theme.musa.colors.semantic.border.neutral}`,
                  cursor: "pointer",
                  borderRadius: theme.musa.border.radius.small,
                  transition: "transform 0.2s ease",
                  padding: theme.musa.spacing[100],
                  display: "flex",
                  alignItems: "center",
                  gap: theme.musa.spacing[100],
                  width: "100%",
                  minHeight: "48px",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.02)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={appStoreImage}
                  alt="Baixar na App Store"
                  style={{
                    height: "32px",
                    width: "auto",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  type="label"
                  size="small"
                  color={theme.musa.colors.semantic.content.primary}
                >
                  Baixar na App Store
                </Typography>
              </button>
            </Stack>
          </Box>

          <Box
            style={{
              backgroundColor:
                theme.musa.colors.semantic.background.neutral.secondary,
              padding: theme.musa.spacing[100],
              borderRadius: theme.musa.border.radius.small,
            }}
          >
            <Typography
              type="body"
              size="small"
              color={theme.musa.colors.semantic.content.secondary}
              style={{ textAlign: "center", lineHeight: "1.4" }}
            >
              💬 Dúvidas? Entre em contato com a equipe Musa para obter suporte
              e mais informações.
            </Typography>
          </Box>
        </Stack>
      </Box>
    </div>
  );
};

export default ModalDeprecated;
